<!-- eslint-disable @angular-eslint/template/eqeqeq -->

<div id="toast" [ngClass]="{'show':_qvs.action_complete}">
    <div id="img"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
    <div id="desc">Added..</div>
  </div>
  
  <div id="toast" [ngClass]="{'show':__project.alreadyAdded}">
    <div id="img"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
    <div id="desc">Already Added..</div>
  </div>
<!-- Quick View Popup -->
<div class="quick-view" *ngIf="!_as.isOnMobilePlatform">
    <p-dialog [(visible)]="_qvs.displayQuickview" [style]="{width: '50vw'}" [modal]="true" [transitionOptions]="_pop.dialogTransitionTime" [dismissableMask]="_pop.closeOutside" (onHide)="_qvs.onHideQuickPopup()">
      <div class="close-popup" (click)="_qvs.displayQuickview=false">
        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="close popup">
      </div>
      <div class="container-fluid" *ngIf="!_qvs.isObjectEmpty(_qvs.productDetail)">
        <div class="mountroot">
          <div class="loader-container">
            <div class="spinner-spinner">
      
            </div>
          </div>
        </div>
      </div>
      <div class="row w-100 relative" *ngIf="_qvs.isObjectEmpty(_qvs.productDetail)">
        <div class="col-12 col-md-6 text-center px-0">
          <div class="product-image-gallery">
            <div class="product-full-image">
              <img src="{{_qvs.productDetail?.image_list[_qvs.activeProductIndex]?.image}}" class="mx-auto my-auto"
                [alt]="_qvs.productDetail?.name"  *ngIf="_qvs.productDetail?.image_list?.length">
            </div>
            <div class="product-thumbnail-image-list" *ngIf="_qvs.productDetail?.image_list.length > 1">
              <div class="product-thumbnail-chip" [ngClass]="{'active-product-thumbnail-chip':_qvs.activeProductIndex==imgi}"
                (mouseover)="_qvs.selectImg(imgi)" *ngFor="let img of _qvs.productDetail?.image_list;let imgi=index">
                <img src="{{img?.image}}" [alt]="_qvs.productDetail?.name" class="mx-auto my-auto">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 py-0 px-0">
          <div class="quick-view-content">
            <div class="quick-view-row">
              <h1>{{_qvs.productDetail?.name}}</h1>
              <div class=" quick-view-brand-sku d-flex">
                <p><span>Brand:</span> {{_qvs.productDetail?.brand_name}}</p>
                <p><span>SKU:</span> {{_qvs.productDetail?.sku}}</p>
              </div>
            </div>
            <div class="quick-view-row"
              *ngIf="(_qvs.productDetail?.calculation_type !== 'sqft_wise') && (_qvs.productDetail?.calculation_type !== 'sheet_wise') && _qvs.productDetail?.price">
              <div class="price-detail" *ngIf="!_qvs.productDetail?.discount">
                <div class="qvm-price"><span> Price: </span> <p>&#8377; {{_qvs.productDetail?.price | number:'1.0-1'}}</p>
                </div>
              </div>
              <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                <span>Price:</span>
                <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                  <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                      number:'1.0-1'}}</s></span>
                  <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                </p>
  
              </div>
              <div class="qvm-n-msg">
                Inclusive of taxes
              </div>
            </div>
            <div class="quick-view-row" *ngIf="_qvs.productDetail?.calculation_type === 'sqft_wise'">
              <div class="price-offer price-detail">
                <div class="qvm-price" *ngIf="!_qvs.productDetail?.discount"><span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}} <span
                      style="font-size: 12px;margin-top: 12px;">/sqft</span> </p>
  
                </div>
                <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                  <span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                    <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                        number:'1.0-1'}}</s></span>
                    <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                  </p>
  
                </div>
                <p class="qvm-n-msg">(Inclusive of taxes)</p>
                <ul class="per-box-ul">
                  <li>
                    <div class="per-box">
                      <p>Size: </p>
                      <p>{{_qvs.productDetail?.width | number:'1.2-2'}} ft X {{_qvs.productDetail?.height | number:'1.2-2'}} ft / Pc
                      </p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box" style="    width: 118px;">
                      <p>Quantity: </p>
                      <p>{{_qvs.productDetail?.in_box}} Pcs / Box</p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box">
                      <p>Coverage Area </p>
                      <p>{{_qvs.productDetail?.covered_area_par_box | number:'1.2-2'}} sqft / Box</p>
  
                    </div>
                  </li>
                </ul>
                <div class="sqft-calculator">
                  <div class="sqft-area-wise">
                    <span>Total Area (sq ft)</span>
                    <input type="number" [(ngModel)]="_qvs.areaSqft" (keyup)="_qvs.areaWiseCalculat()">
                  </div>
  
                  <div class="total-sqft-area-price">
                    <p class="total-sqft-area-price-p"><span>Total Price:</span> &#8377;{{_qvs.total_Sqft_amount |
                      number:'1.0-1'}}</p>
                    <p class="qvm-n-msg">(Inclusive of taxes)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="quick-view-row" *ngIf="_qvs.productDetail?.calculation_type === 'sheet_wise'">
              <div class="price-offer price-detail">
                <div class="qvm-price" *ngIf="!_qvs.productDetail?.discount"><span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}} <span
                      style="font-size: 12px;margin-top: 12px;">/sqft</span> </p>
  
                </div>
  
                <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                  <span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                    <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                        number:'1.0-1'}}</s></span>
                    <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                  </p>
  
                </div>
                <p class="qvm-n-msg">(Inclusive of taxes)</p>
                <ul class="per-box-ul">
                  <li>
                    <div class="per-box">
                      <p>Coverage Area </p>
                      <p>{{_qvs.productDetail?.covered_area_par_sheet | number:'1.2-2'}} sqft / Board</p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box">
                      <p>Price </p>
                      <p>&#8377; {{_qvs.productDetail?.par_box_amount | number:'1.0-1'}} / Board</p>
  
                    </div>
                  </li>
                </ul>
                <div class="sqft-calculator">
                  <div class="total-sqft-area-price">
                    <p class="total-sqft-area-price-p"><span>Total Price:</span> &#8377;{{_qvs.total_Sqft_amount |
                      number:'1.0-1'}}</p>
                    <p class="qvm-n-msg">(Inclusive of taxes)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="quick-view-row" *ngIf="_qvs.productDetail?.product_calculation?.calculation_type === 'meter_wise'">
              <div class="price-offer price-detail">
                <div class="qvm-price" *ngIf="!_qvs.productDetail?.discount"><span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.unit_price | number:'1.0-1'}} <span
                      style="font-size: 12px;margin-top: 12px;">/meter</span> </p>
  
                </div>
  
                <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                  <span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                    <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                        number:'1.0-1'}}</s></span>
                    <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                  </p>
  
                </div>
                <p class="qvm-n-msg">(Inclusive of taxes)</p>
                <ul class="per-box-ul">
                  <li>
                    <div class="per-box">
                      <p>Roll length  </p>
                      <p>{{_qvs.productDetail?.product_calculation?.length | number:'1.2-2'}} meter</p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box">
                      <p>Price </p>
                      <p>&#8377; {{_qvs.productDetail?.product_calculation?.per_roll_amount | number:'1.0-1'}} / Roll</p>
  
                    </div>
                  </li>
                </ul>
                <div class="sqft-calculator">
                  <div class="total-sqft-area-price">
                    <p class="total-sqft-area-price-p"><span>Total Price:</span> &#8377;{{_qvs.totalamount |
                      number:'1.0-1'}}</p>
                    <p class="qvm-n-msg">(Inclusive of taxes)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="quick-view-row"
              *ngIf="_qvs.productDetail?.full_description && _qvs.productDetail?.calculation_type !== 'sqft_wise' && _qvs.productDetail?.calculation_type !== 'sheet_wise'">
              <p-accordion>
                <p-accordionTab header="Description" [selected]="true">
                  <div class="qvm-description">
                    <p>{{_qvs.productDetail?.full_description}}</p>
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
            <div class="quick-view-row">
              <div class="quick-view-action">
                <div class="quick-view-action-row">
                  <div class="product-quantity"  [ngClass]="{'w-100':_cart.is_my_list}">
                    <div class="product-btns" [ngClass]="{'ass-product-btns':__project.selectedProject?.is_assigned}">
                      <button [ngClass]="{'product-btns-disabled':_qvs.selectedQuantity == 1 }" (click)="_qvs.decreaseQty()">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H5.5C4.94772 13.5 4.5 13.0523 4.5 12.5Z"
                            fill="#222222" />
                        </svg>
  
                      </button>
                      <!-- [ngClass]="{'qty-input-width':_project.selectedProject?.is_assigned}" -->
                      <input type="text" [(ngModel)]="_qvs.selectedQuantity"  min="1" [max]="20" (keyup)="_qvs.addQty()">
                      <button (click)="_qvs.increaseQty()"
                        [ngClass]="{'product-btns-disabled':_qvs.selectedQuantity == 20 && _qvs.productDetail?.calculation_type !=='sqft_wise' }">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H5.5C4.94772 13.5 4.5 13.0523 4.5 12.5Z"
                            fill="#222222" />
                          <path
                            d="M12.5 4.5C13.0523 4.5 13.5 4.94772 13.5 5.5L13.5 19.5C13.5 20.0523 13.0523 20.5 12.5 20.5C11.9477 20.5 11.5 20.0523 11.5 19.5L11.5 5.5C11.5 4.94772 11.9477 4.5 12.5 4.5Z"
                            fill="#222222" />
                        </svg>
  
                      </button>
                    </div>
                  </div>
                  <button class="qvm-add-to-card-btn"  (click)="this._qvs.addToCart(_qvs.productDetail)">Add To cart</button>
                </div>
                <div class="quick-view-action-save-row">
                    <!-- (click)="_qvs.addProductSpace(tagged_product,activePos,'addtospace')" -->
                  <button class="save-idea-card-btn" style="cursor: pointer;" (click)="_sis.addProductSpace(_qvs.productDetail,_qvs.selectedProductIndex,'addToSpace')">
                    <svg width="17" height="18" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style="margin-right: 6px;">
                      <path
                        d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                        fill="#fc9918" />
                    </svg>
                    Save Idea
                  </button>
                </div>
                <div class="quick-view-action-save-row">
                  <a class="see-full-details-card-btn pl-0" [routerLink]="['/p/', _qvs.productDetail?.slug_name]"> See
                    Full
                    Details</a>
                </div>
  
  
                <div class="cp shareimage text-left mt-3"
                  style="align-items: center; margin-top: 16px !important;padding-bottom: 0px;">
                  <span class="ng-tns-c7-9 pr-2 color-s">Share</span>
                  <share-buttons [theme]="'circles-dark'" [include]="['whatsapp','facebook','pinterest','linkedin']"
                    [show]="4" [tags]="'afterbricks'">
                  </share-buttons>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </p-dialog>
  </div>

  <div class="quick-view" *ngIf="_as.isOnMobilePlatform">

    <p-sidebar [(visible)]="_qvs.displayQuickview" position="bottom">
      <div class="close-popup" (click)="_qvs.displayQuickview=false">
        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="close popup">
      </div>
      <div class="container-fluid" *ngIf="!_qvs.isObjectEmpty(_qvs.productDetail)">
        <div class="mountroot">
          <div class="loader-container">
            <div class="spinner-spinner">
      
            </div>
          </div>
        </div>
      </div>
      <div class="row w-100 relative" *ngIf="_qvs.isObjectEmpty(_qvs.productDetail)">
        <div class="col-12 text-center px-0">
          <div class="product-image-gallery">
            <div class="product-full-image">
              <img src="{{_qvs.productDetail?.image_list[_qvs.activeProductIndex]?.image}}" class="mx-auto my-auto"
                [alt]="_qvs.productDetail?.name"  *ngIf="_qvs.productDetail?.image_list?.length">
            </div>
            <div class="product-thumbnail-image-list" *ngIf="_qvs.productDetail?.image_list.length > 1">
              <div class="product-thumbnail-chip" [ngClass]="{'active-product-thumbnail-chip':_qvs.activeProductIndex==imgi}"
                (mouseover)="_qvs.selectImg(imgi)" *ngFor="let img of _qvs.productDetail?.image_list;let imgi=index">
                <img src="{{img?.image}}" [alt]="_qvs.productDetail?.name" class="mx-auto my-auto">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12  py-0 px-0">
          <div class="quick-view-content">
            <div class="quick-view-row">
              <h1>{{_qvs.productDetail?.name}}</h1>
              <div class=" quick-view-brand-sku d-flex">
                <p><span>Brand:</span> {{_qvs.productDetail?.brand_name}}</p>
                <p><span>SKU:</span> {{_qvs.productDetail?.sku}}</p>
              </div>
            </div>
            <div class="quick-view-row"
              *ngIf="(_qvs.productDetail?.calculation_type !== 'sqft_wise') && (_qvs.productDetail?.calculation_type !== 'sheet_wise') && _qvs.productDetail?.price">
              <div class="price-detail" *ngIf="!_qvs.productDetail?.discount">
                <div class="qvm-price"><span> Price: </span> <p>&#8377; {{_qvs.productDetail?.price | number:'1.0-1'}}</p>
                </div>
              </div>
              <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                <span>Price:</span>
                <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                  <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                      number:'1.0-1'}}</s></span>
                  <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                </p>
  
              </div>
              <div class="qvm-n-msg">
                Inclusive of taxes
              </div>
            </div>
            <div class="quick-view-row" *ngIf="_qvs.productDetail?.calculation_type === 'sqft_wise'">
              <div class="price-offer price-detail">
                <div class="qvm-price" *ngIf="!_qvs.productDetail?.discount"><span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.price | number:'1.0-1'}} <span
                      style="font-size: 12px;margin-top: 12px;">/sqft</span> </p>
  
                </div>
                <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                  <span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                    <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                        number:'1.0-1'}}</s></span>
                    <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                  </p>
  
                </div>
                <p class="qvm-n-msg">(Inclusive of taxes)</p>
                <ul class="per-box-ul">
                  <li>
                    <div class="per-box">
                      <p>Size: </p>
                      <p>{{_qvs.productDetail?.width | number:'1.2-2'}} ft X {{_qvs.productDetail?.height | number:'1.2-2'}} ft / Pc
                      </p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box" style="    width: 118px;">
                      <p>Quantity: </p>
                      <p>{{_qvs.productDetail?.in_box}} Pcs / Box</p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box">
                      <p>Coverage Area </p>
                      <p>{{_qvs.productDetail?.covered_area_par_box | number:'1.2-2'}} sqft / Box</p>
  
                    </div>
                  </li>
                </ul>
                <div class="sqft-calculator">
                  <div class="sqft-area-wise">
                    <span>Total Area (sq ft)</span>
                    <input type="number" [(ngModel)]="_qvs.areaSqft" (keyup)="_qvs.areaWiseCalculat()">
                  </div>
  
                  <div class="total-sqft-area-price">
                    <p class="total-sqft-area-price-p"><span>Total Price:</span> &#8377;{{_qvs.total_Sqft_amount |
                      number:'1.0-1'}}</p>
                    <p class="qvm-n-msg">(Inclusive of taxes)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="quick-view-row" *ngIf="_qvs.productDetail?.calculation_type === 'sheet_wise'">
              <div class="price-offer price-detail">
                <div class="qvm-price" *ngIf="!_qvs.productDetail?.discount"><span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.unit_price | number:'1.0-1'}} <span
                      style="font-size: 12px;margin-top: 12px;">/sqft</span> </p>
  
                </div>
  
                <div class="qvm-price" *ngIf="_qvs.productDetail?.discount">
                  <span>Price:</span>
                  <p>&#8377;{{_qvs.productDetail?.effective_price | number:'1.0-1'}}
                    <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{_qvs.productDetail?.price |
                        number:'1.0-1'}}</s></span>
                    <span class="dis-off">{{_qvs.productDetail?.discount}}% off</span>
                  </p>
  
                </div>
                <p class="qvm-n-msg">(Inclusive of taxes)</p>
                <ul class="per-box-ul">
                  <li>
                    <div class="per-box">
                      <p>Coverage Area </p>
                      <p>{{_qvs.productDetail?.covered_area_par_sheet | number:'1.2-2'}} sqft / Board</p>
  
                    </div>
                  </li>
                  <li>
                    <div class="per-box">
                      <p>Price </p>
                      <p>&#8377; {{_qvs.productDetail?.par_box_amount | number:'1.0-1'}} / Board</p>
  
                    </div>
                  </li>
                </ul>
                <div class="sqft-calculator">
                  <div class="total-sqft-area-price">
                    <p class="total-sqft-area-price-p"><span>Total Price:</span> &#8377;{{_qvs.total_Sqft_amount |
                      number:'1.0-1'}}</p>
                    <p class="qvm-n-msg">(Inclusive of taxes)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="quick-view-row"
              *ngIf="_qvs.productDetail?.full_description && _qvs.productDetail?.calculation_type !== 'sqft_wise' && _qvs.productDetail?.calculation_type !== 'sheet_wise'">
              <p-accordion>
                <p-accordionTab header="Description" [selected]="true">
                  <div class="qvm-description">
                    <p>{{_qvs.productDetail?.full_description}}</p>
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
            <div class="quick-view-row">
              <div class="quick-view-action">
                <div class="quick-view-action-row">
                  <div class="product-quantity"  [ngClass]="{'w-100':_cart.is_my_list}">
                    <div class="product-btns" [ngClass]="{'ass-product-btns':__project.selectedProject?.is_assigned}">
                      <button [ngClass]="{'product-btns-disabled':_qvs.selectedQuantity == 1 }" (click)="_qvs.decreaseQty()">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H5.5C4.94772 13.5 4.5 13.0523 4.5 12.5Z"
                            fill="#222222" />
                        </svg>
  
                      </button>
                      <!-- [ngClass]="{'qty-input-width':_project.selectedProject?.is_assigned}" -->
                      <input type="text" [(ngModel)]="_qvs.selectedQuantity"  min="1" [max]="20" (keyup)="_qvs.addQty()">
                      <button (click)="_qvs.increaseQty()"
                        [ngClass]="{'product-btns-disabled':_qvs.selectedQuantity == 20 && _qvs.productDetail?.calculation_type !=='sqft_wise' }">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H5.5C4.94772 13.5 4.5 13.0523 4.5 12.5Z"
                            fill="#222222" />
                          <path
                            d="M12.5 4.5C13.0523 4.5 13.5 4.94772 13.5 5.5L13.5 19.5C13.5 20.0523 13.0523 20.5 12.5 20.5C11.9477 20.5 11.5 20.0523 11.5 19.5L11.5 5.5C11.5 4.94772 11.9477 4.5 12.5 4.5Z"
                            fill="#222222" />
                        </svg>
  
                      </button>
                    </div>
                  </div>
                  <button class="qvm-add-to-card-btn"  (click)="this._qvs.addToCart(_qvs.productDetail)">Add To cart</button>
                </div>
                <div class="quick-view-action-save-row">
                    <!-- (click)="_qvs.addProductSpace(tagged_product,activePos,'addtospace')" -->
                  <button class="save-idea-card-btn" style="cursor: pointer;" (click)="_sis.addProductSpace(_qvs.productDetail,_qvs.selectedProductIndex,'addToSpace')">
                    <svg width="17" height="18" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style="margin-right: 6px;">
                      <path
                        d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                        fill="#fc9918" />
                    </svg>
                    Save Idea
                  </button>
                </div>
                <div class="quick-view-action-save-row">
                  <button class="see-full-details-card-btn pl-0" routerLink="../p/{{_qvs.productDetail?.slug_name}}"> See
                    Full
                    Details</button>
                </div>
  
  
                <div class="cp shareimage text-left mt-3"
                  style="align-items: center; margin-top: 16px !important;padding-bottom: 0px;">
                  <span class="ng-tns-c7-9 pr-2 color-s">Share</span>
                  <share-buttons [theme]="'circles-dark'" [include]="['whatsapp','facebook','pinterest','linkedin']"
                    [show]="4" [tags]="'afterbricks'">
                  </share-buttons>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
  </p-sidebar>
  </div>
  <!-- End Quick View popup -->